<template>
   <main class="position-relative">
      <iframe id="historiaExterna" src="https://ccmdobrasil.com.br/historiakawashima/index.html"></iframe>
   </main>
</template>

<script>

import $ from 'jquery'
import { mapState } from 'vuex'

export default {
	name: "História",
   computed: {
		... mapState({
			clienteData: state => state.clienteData
		})
	},
   watch: {
      clienteData: {
			handler: function () {
				this.setAltura()
			},
			deep: true
		},
   },
   methods: {
      setAltura : function () {
         $("#historiaExterna").height('calc(100dvh - '+ document.querySelector("header").offsetHeight +'px)')
      }
   },
   mounted() {
      $(window).resize(() => this.setAltura())
      this.setAltura()
   }
}

</script>

<style scoped>

iframe {
   width: 100%;
   height: 100%;
   overflow: hidden;
   position: absolute;
   top: 0;
   left: 0;
}

</style>